var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex jcb aic mb-24px"},[_c('div',{staticClass:"fs-xl fw-500 text-dark"},[_vm._v(_vm._s(`${_vm.$t('label.ticket')} #${_vm.ticketId}`))])]),_c('ticket-messenger',{staticClass:"messenger-wrapper",attrs:{"ticket":_vm.ticket,"with-image-upload":""},on:{"close":_vm.showCloseTicketModal,"send":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }